<template>
  <div>
    <div class="container-fluid full-heigh">
      <div v-if="isWaiting" id="preloader">
        <div data-loader="circle-side"></div>
      </div>
      <!-- /Preload -->
      <div class="row row-height">
        <hello :partner="partner" show-campaign />

        <div id="start" class="col-lg-6 content-right p-0 h-screen vld-parent">
          <div class="w-100 h-100">
            <div class="right-spacing">
              <div id="wizard_container">
                <div id="top-wizard">
                  <div id="progressbar"></div>
                </div>
                <!-- /top-wizard -->
                <input id="website" name="website" type="text" value />
                <!-- Leave for security protection, read docs for details -->
                <a id="logo" href="/">
                  <img
                    alt
                    height="30"
                    src="https://s3-eu-west-1.amazonaws.com/mukellef-assets/icon.svg"
                    style="display: none"
                    width="30"
                  />
                </a>
                <div id="middle-wizard">
                  <div v-if="step !== 0 && !isWebView" class="row mb-2">
                    <div class="col-5 mb-2">
                      <button
                        @click="redirectToPanel()"
                        :disabled="!dashboardUrl"
                        class="mukellef-secondary-btn panel-button"
                      >
                        {{ $t('Panele dön') }}
                      </button>
                    </div>
                  </div>

                  <!-- // US -->
                  <div class="step" v-if="$route.params.type === 'us'">
                    <us-step1 v-if="step === 1" :us-products="usProducts" :states="states" ref="step1" />
                    <us-step2 v-if="step === 2" :is-new-user="isNewUser" ref="step2" />
                    <us-step3 v-if="step === 3" :us-products="usProducts" :states="states" ref="step3" />
                    <us-step4 v-if="step === 4" :us-products="usProducts" :states="states" ref="step4" />
                    <us-step5
                      v-if="step === 5"
                      ref="step5"
                      @subtotal="setTotal"
                      @pay="finishPayment()"
                      @set-loading="setLoading"
                    />
                  </div>

                  <!-- // UK -->
                  <div class="step" v-if="$route.params.type === 'uk'">
                    <uk-step1 v-if="step === 1" ref="step1" />
                    <uk-step2 v-if="step === 2" :is-new-user="isNewUser" ref="step2" />
                    <uk-step3 v-if="step === 3" ref="step3" />
                    <uk-step4
                      v-if="step === 4"
                      ref="step4"
                      @subtotal="setTotal"
                      @pay="finishPayment()"
                      @set-loading="setLoading"
                    />
                  </div>

                  <!-- // NORMAL -->
                  <template v-if="$route.params.type === undefined">
                    <div class="step" v-if="isWebsiteMukellef">
                      <mukellef-register-step1 v-if="step === 1" ref="step1" />
                      <mukellef-register-step2 v-if="step === 2" ref="step2" />
                      <mukellef-register-step3 :is-new-user="isNewUser" v-if="step === 3" ref="step3" />
                      <mukellef-register-step4 v-if="step === 4" ref="step4" />
                      <mukellef-register-step5
                        v-if="step === 5"
                        ref="step5"
                        @subtotal="setTotal"
                        @set-loading="setLoading"
                      />
                    </div>
                  </template>

                  <div v-if="step === 0" class="step">
                    <div class="submit step wizard-step current">
                      <h3 v-if="!alreadyPaid" class="main_question wizard-header">
                        {{ $t('Ödemeniz başarıyla yapıldı') }}
                      </h3>
                      <h3 v-if="alreadyPaid" class="main_question wizard-header">
                        {{ $t('Başvurunuz alındı') }}
                      </h3>

                      <p>
                        {{ $t('Evrak kontrol ediliyor') }}
                      </p>

                      <div v-if="!isWebView">
                        <div class="form-group">
                          <button @click="redirectToPanel()" :disabled="!dashboardUrl" class="submit">
                            {{ $t('Panele git') }}
                          </button>
                        </div>

                        <div class="form-group">
                          <a href="#" @click="logout">{{ $t('Çıkış yap') }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /middle-wizard -->
                <div v-if="step !== 0" id="bottom-wizard" class="pb-3">
                  <div class="btn-toolbar row" role="toolbar" aria-label="Toolbar with button groups">
                    <div
                      v-if="!checkLastStep"
                      class="btn-group col-lg-5 col-md-4 col-sm-4 col-12 first-button-group"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        v-tippy="
                          this.$t('Randevu tooltip', {
                            type: this.$t('Kuruluş'),
                          })
                        "
                        class="float-left backward reservation-button w-100"
                        name="reservation"
                        type="button"
                        @click="goToReservationPage($route.params.type)"
                      >
                        {{ $t('schedule_an_appointment').toUpperCase() }}
                      </button>
                    </div>
                    <div class="col"></div>
                    <div
                      class="btn-right-group"
                      :class="[
                        !checkLastStep ? ['col-lg-6', 'col-md-5', 'col-sm-6', 'col-12'] : ['col-12', 'col-sm-9'],
                      ]"
                      role="group"
                      aria-label="Second group"
                    >
                      <button
                        v-if="step > 1"
                        class="backward w-100 h-100"
                        name="backward"
                        type="button"
                        @click="backward"
                      >
                        {{ $t('Önceki').toUpperCase() }}
                      </button>

                      <button
                        v-if="!checkLastStep"
                        :disabled="isWaiting"
                        class="forward w-100 h-100"
                        name="forward"
                        type="button"
                        @click="forward"
                      >
                        {{ $t('Devam Et').toUpperCase() }}
                      </button>
                      <button
                        v-else
                        :disabled="isWaiting || isLoading"
                        class="process submit w-100 h-100 relative"
                        name="process"
                        type="button"
                        @click="forward"
                      >
                        <loading :active="isLoading" :is-full-page="false" background-color="#b1b3b1">
                          <div>
                            <Lottie small-size />
                          </div>
                        </loading>
                        {{ $t('Ödemeyi Tamamla').toUpperCase() }} ( {{ total }} )
                      </button>
                    </div>
                  </div>
                  <div v-if="checkLastStep" class="float-right mt-2">
                    <img
                      v-if="$route.params.type === undefined"
                      class="card-type-image"
                      src="/img/icons/kredi-kart-tipleri.png"
                    />
                    <img v-else class="card-type-image-global" src="/img/icons/kredi-kart-tipleri-global.png" />
                  </div>
                </div>
                <!-- /bottom-wizard -->
                <!-- /row -->
              </div>
              <!-- /Wizard container -->
            </div>
            <!-- /content-right-->
          </div>
        </div>
      </div>
      <!-- /row-->
    </div>

    <TitleDeedModal />
    <CarPermitModal />
    <CarAgreementModal />
    <HomeRentalContractModal />
    <UserTcIdentityModal />
    <OtherDocumentModal />
    <PlaceOfResidenceModal />
    <CarSaleNotaryModal />
    <CarInvoiceModal />
    <!-- Videos -->
    <HowToChooseModal />
    <WhyAskingTCModal />
    <WhyContactInfoModal />
    <HowToPayModal />
    <CompanyAddressModal />
    <CommitmentModal />
    <PaymentVerifyModal />
    <EstablishAtDescriptionModal />
  </div>
</template>
<script>
import PlaceOfResidenceModal from './../components/modals/PlaceOfResidenceModal';
import OtherDocumentModal from './../components/modals/OtherDocumentModal';
import UserTcIdentityModal from './../components/modals/UserTcIdentityModal';
import HomeRentalContractModal from './../components/modals/HomeRentalContractModal';
import TitleDeedModal from './../components/modals/TitleDeedModal';
import CarAgreementModal from './../components/modals/CarAgreementModal';
import CarPermitModal from './../components/modals/CarPermitModal';
import CarInvoiceModal from './../components/modals/CarInvoiceModal';
import CarSaleNotaryModal from './../components/modals/CarSaleNotaryModal';
import EstablishAtDescriptionModal from './../components/modals/EstablishAtDescriptionModal';
// Videos
import HowToChooseModal from './../components/modals/videos/HowToChooseModal';
import WhyAskingTCModal from './../components/modals/videos/WhyAskingTCModal';
import HowToPayModal from './../components/modals/videos/HowToPayModal';
import WhyContactInfoModal from './../components/modals/videos/WhyContactInfoModal';
import CompanyAddressModal from './../components/modals/videos/CompanyAddressModal';
import CommitmentModal from '@/components/modals/CommitmentModal';
import PaymentVerifyModal from '@/components/modals/PaymentVerify';

import UsStep1 from '@/components/register/us/UsStep1';
import UsStep4 from '@/components/register/us/UsStep4';
import UsStep5 from '@/components/register/us/UsStep5';
import UsStep3 from '@/components/register/us/UsStep3';
import UsStep2 from '@/components/register/us/UsStep2';

import UkStep1 from '@/components/register/uk/UkStep1';
import UkStep2 from '@/components/register/uk/UkStep2';
import UkStep3 from '@/components/register/uk/UkStep3';
import UkStep4 from '@/components/register/uk/UkStep4';

import MukellefRegisterStep1 from '@/components/register/tr/mukellef/RegisterStep1';
import MukellefRegisterStep2 from '@/components/register/tr/mukellef/RegisterStep2';
import MukellefRegisterStep3 from '@/components/register/tr/mukellef/RegisterStep3';
import MukellefRegisterStep4 from '@/components/register/tr/mukellef/RegisterStep4';
import MukellefRegisterStep5 from '@/components/register/tr/mukellef/RegisterStep5';

import ProductStore from '../stores/product';
import CompanyStore from '../stores/company';

export default {
  data() {
    return {
      isLoading: false,
      step: null,
      total: null,
      alreadyPaid: false,
      partner: null,
      dashboardUrl: null,
      usProducts: [],
      lastSteppedTime: new Date(),
      states: [],
      isNewUser: false,
    };
  },
  created() {
    if (this.$route.query.companyId && this.$route.query.companyId === 'newuser') {
      this.isNewUser = true;
    }
    $axios.get('/tenant/companies').then((s) => {
      const companies = s.data.data;
      if (companies && companies.length > 1) {
        this.isNewUser = true;
      }
    });
    this.startWaiting();
    $axios.all([this.getSelfData(), this.getProductData(), this.getStates()]).then(
      $axios.spread((firstResponse, secondResponse, thirdResponse) => {
        let form;
        if (this.$store.state.selfMeData.id) {
          form = JSON.parse(JSON.stringify(this.$store.state.selfMeData));
        }
        this.dashboardUrl = this.getDashboardUrl();
        let queryString = '';

        for (const [k, v] of Object.entries(this.$route.query)) {
          queryString += queryString ? '&' : '?';
          if (k !== 'step') queryString += k.toString() + '=' + v.toString();
          else queryString += k.toString() + '=1';
        }
        if (
          (form && form.step === 0 && this.$route.query.companyId !== 'newuser') ||
          this.$route.query.status === 'failure'
        ) {
          this.step = form.step;
        } else {
          this.step = 1;
        }

        this.callMukellefApp();

        this.partner = this.$route.query.partner;

        if (secondResponse) {
          this.usProducts = secondResponse.data.data;
        }
        if (thirdResponse) {
          const states = thirdResponse.data.data;
          this.states = states.filter((state) => state.key !== 'Teksas');
        }
        this.endWaiting();
      })
    );
  },
  computed: {
    checkLastStep() {
      return (
        (this.step === 4 && this.$route.params.type === 'uk') ||
        (this.step === 5 && (this.$route.params.type === 'us' || this.$route.params.type === undefined))
      );
    },
  },
  methods: {
    setLoading(data) {
      this.isLoading = data;
    },
    callMukellefApp() {
      if (this.step === 0) {
        if (window.MukellefApp) {
          const messageData = JSON.stringify({
            status: 'success',
            message: this.$route.query.message,
          });
          window.MukellefApp.postMessage(messageData);
        }
      }
    },
    finishPayment() {
      this.step = 0;
      this.callMukellefApp();
    },
    getSelfData() {
      if (this.$route.query.companyId !== 'newuser') {
        return this.$store.dispatch('getSelfWithCompanies');
      }
      return null;
    },
    getProductData() {
      if (this.$route.params.type === 'us') {
        const codes = [
          'USEXPRESSFORMATION_DELAWARE',
          'USFRANCHISETAX_DELAWARE_NEW',
          'USSTATEFEE_DELAWARE',
          'USSTATEFEE_TEKSAS',
          'USFRANCHISETAX_FLORIDA_NEW',
          'USSTATEFEE_FLORIDA',
          'USFRANCHISETAX_WYOMING_NEW',
          'USSTATEFEE_WYOMING',
          'OTHERSTATEADDITIONALSETUPFEE',
          'US_FORMATION_PACKAGE',
          'US_FORMATION',
          'USEIN',
          'US_BOI',
          'US_ADDRESS_PACKAGE_PRODUCT',
          'US_TAX_PACKAGE_PRODUCT',
          'USITIN_IN_PACKAGE',
          'US_1040_NR_FORM',
          'USITIN',
          'US_1065_FORM',
          'US_1120_FORM',
        ];
        return ProductStore.dispatch('getProductsByCodes', {
          codes: codes,
          sort: true,
        });
      } else {
        return null;
      }
    },
    getStates() {
      if (this.$route.params.type === 'us') {
        return CompanyStore.dispatch('getStates');
      } else {
        return null;
      }
    },
    redirectToPanel() {
      window.location =
        this.dashboardUrl + '?companyId=' + (this.$store.state.companyData ? this.$store.state.companyData.id : '');
    },
    setTotal(total) {
      this.total = this.formatPrice(total.price, total.currency);
    },
    forward() {
      let func = 'sendForm';
      const step = this.step;

      if (Math.abs(new Date().getTime() - this.lastSteppedTime.getTime()) < 1000) {
        return;
      }
      switch (this.$route.params.type) {
        case 'us':
          if (step === 2) {
            func = 'openSummaryModal';
          } else if (step === 3) {
            func = 'openSummaryModal';
          } else if (step === 4) {
            func = 'openSummaryModal';
          }
          break;
        case 'uk':
          if (step === 3) {
            func = 'openSummaryModal';
          }
          break;
      }
      this.lastSteppedTime = new Date();
      this.$refs['step' + step][func](() => {
        window.scrollTo({ top: 0 });
        this.endWaiting();
        this.step++;
      });
    },
    backward() {
      this.startWaiting();
      this.step--;
      window.scrollTo({ top: 0 });
      this.toastClear();
    },
    toastClear() {
      this.$toasted.clear();
    },
  },
  components: {
    PaymentVerifyModal,
    CommitmentModal,
    HomeRentalContractModal,
    PlaceOfResidenceModal,
    UserTcIdentityModal,
    CarSaleNotaryModal,
    OtherDocumentModal,
    CarAgreementModal,
    CarInvoiceModal,
    TitleDeedModal,
    CarPermitModal,
    // Videos
    HowToChooseModal,
    WhyAskingTCModal,
    WhyContactInfoModal,
    HowToPayModal,
    CompanyAddressModal,
    EstablishAtDescriptionModal,
    MukellefRegisterStep1,
    MukellefRegisterStep2,
    MukellefRegisterStep3,
    MukellefRegisterStep4,
    MukellefRegisterStep5,
    UsStep1,
    UsStep2,
    UsStep3,
    UsStep4,
    UsStep5,
    UkStep1,
    UkStep2,
    UkStep3,
    UkStep4,
  },
};
</script>
